import { Box, Typography } from "@mui/material";
import { colors } from "../../theme/theme";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const links = [
    { name: "About Us", path: "/about-us" },
    { name: "Terms of Use", path: "/terms-of-use" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Affiliate Disclosure", path: "/affiliate-disclosure" },
  ];

  return (
    <Box
      sx={{
        mt: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Logo */}
      <img
        src={require("../../assets/images/handpik.png")}
        alt="logo"
        style={{
          width: "100px",
        }}
      />

      {/* Quick Links */}
      <Box
        sx={{
          mt: 2,
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          justifyContent: "center",
          maxWidth: "75%",
        }}
      >
        {links.map((link, index) => (
          <Typography
            key={index}
            sx={{
              fontFamily: "Poppins-Light",
              fontSize: "10px",
              color: "#000",
              cursor: "pointer",
              "&:hover": { textDecoration: "underline", color: "#FF5722" },
            }}
            onClick={() => navigate(link.path)}
          >
            {link.name}
          </Typography>
        ))}
      </Box>

      {/* <Stack direction="row" mt={2} gap={2}>
        <Typography
          sx={{
            color: colors.lightColor,
            fontFamily: "Poppins-Bold",
            fontSize: "11px",
            textAlign: "center",
            lineHeight: "14px",
          }}
        >
          PHONE NUMBER
        </Typography>

        <Stack direction="row">
          <img
            src={require("../../assets/icons/phone.png")}
            alt="phone"
            style={{
              width: "15px",
              height: "15px",
              objectFit: "contain",
              marginRight: "5px",
            }}
          />
          <Typography
            sx={{
              color: colors.lightColor,
              fontFamily: "Poppins-Light",
              fontSize: "11px",
              textAlign: "center",
              lineHeight: "14px",
            }}
          >
            +9231-222-3333-4
          </Typography>
        </Stack>
      </Stack>

      <Stack direction="row" mt={2} gap={2} maxWidth={"75%"}>
        <Typography
          sx={{
            color: colors.lightColor,
            fontFamily: "Poppins-Bold",
            fontSize: "11px",
            textAlign: "center",
            lineHeight: "14px",
          }}
        >
          ADDRESS
        </Typography>

        <Stack direction="row">
          <img
            src={require("../../assets/icons/home.png")}
            alt="home"
            style={{
              width: "15px",
              height: "15px",
              objectFit: "contain",
              marginRight: "5px",
            }}
          />
          <Typography
            sx={{
              color: colors.lightColor,
              fontFamily: "Poppins-Light",
              fontSize: "11px",
              textAlign: "center",
              lineHeight: "14px",
            }}
          >
            Unit A10 77 Bizspace Business Park, Kings Road Birmingham, UK
          </Typography>
        </Stack>
      </Stack> */}

      <Box
        sx={{
          backgroundColor: colors.lightColor,
          height: "4px",
          width: "95%",
          mt: 3,
        }}
      />

      <Typography
        sx={{
          mb: 2,
          mt: 2,
          fontFamily: "Poppins-Light",
          color: colors.lightColor,
          fontSize: "8px",
        }}
      >
        Copyright © 2025. ALl Rights Reserved By HandPik.AI
      </Typography>
    </Box>
  );
};

export default Footer;
